import { Currency } from "@izettle/constants"

import getLocale from "./get-locale"

export const formatCurrency = (amount: number, currency: Currency) => {
  return new Intl.NumberFormat(getLocale(), { style: "currency", currency }).format(
    amount / 100,
  )
}

export const formatTime = (dateTime: string) => {
  return new Intl.DateTimeFormat(getLocale(), {
    hour: "numeric",
    minute: "numeric",
  }).format(new Date(dateTime))
}
